module.exports = __webpack_public_path__ + "static/media/icon-small-group.87d04c2d.svg";